import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";

export function DashboardShell({ title, subtitle, nav, children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const initials = (user?.name || "U").split(" ").map((s) => s[0]).slice(0, 2).join("");

  return (
    <div className="min-h-screen flex bg-[#FBFBFA]">
      <aside className="hidden lg:flex w-64 flex-col bg-[#595C2B] text-white p-6 fixed inset-y-0">
        <div className="flex items-center gap-2 mb-10">
          <img src="/logo_mark.png" alt="Up Smart Learning logo" className="h-9 w-9 object-contain" />
          <span className="font-display text-lg font-bold">Up Smart</span>
        </div>
        <nav className="flex-1 space-y-1">
          {(nav || []).map((n) => (
            <a key={n.label} href={n.href} data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
              className="flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm text-white/70 hover:bg-white/10 hover:text-white transition-colors">
              <n.icon className="h-4 w-4" /> {n.label}
            </a>
          ))}
        </nav>
        <div className="border-t border-white/10 pt-4">
          <div className="flex items-center gap-3 mb-3">
            <div className="h-9 w-9 rounded-full bg-[#BA8A30] text-[#595C2B] flex items-center justify-center text-sm font-bold uppercase">{initials}</div>
            <div className="min-w-0">
              <p className="text-sm font-semibold truncate">{user?.name}</p>
              <p className="text-xs text-white/50 capitalize">{user?.role}</p>
            </div>
          </div>
          <Button onClick={async () => { await logout(); navigate("/login"); }} variant="ghost" className="w-full justify-start text-white/70 hover:bg-white/10 hover:text-white rounded-xl" data-testid="logout-btn">
            <LogOut className="h-4 w-4 mr-2" /> Log out
          </Button>
        </div>
      </aside>

      <main className="flex-1 lg:ml-64 p-6 md:p-10">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="font-display text-3xl font-bold text-[#595C2B] tracking-tight">{title}</h1>
            {subtitle && <p className="text-slate-500 mt-1">{subtitle}</p>}
          </div>
          <Button onClick={async () => { await logout(); navigate("/login"); }} variant="outline" className="lg:hidden rounded-full" data-testid="logout-btn-mobile">
            <LogOut className="h-4 w-4" />
          </Button>
        </div>
        {children}
      </main>
    </div>
  );
}
